'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:UsersCtrl
 * @description
 * # UsersCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('UsersCtrl', function ($location, cfpLoadingBar, userService, FlashService) {

    var usersVm = this;
    usersVm.usersList = {};
    usersVm.selected = {};
    usersVm.select = select;
    usersVm.edit = edit;
    usersVm.changePassword = changePassword;
    usersVm.lockoutUser = lockoutUser;
    usersVm.unlockUser = unlockUser;

    activate();

    function activate() {
      cfpLoadingBar.start();
      userService.GetAll().then(
        /**
         * @param response { { accountLocked: boolean }[] }
         */
        function (response) {
          if (response !== null) {
            usersVm.usersList = response.map(user => ({
              ...user,
              selected: false,
              accountStatus: user.accountLocked ? 'Locked' : 'Normal'
            }));
          }
        }, error => {
          if (error.status === 401) {
            // Do something
            FlashService.Error('You are not authorised to go this page');
          }
          FlashService.Error('Network Error. Try reloading the page', false);
        }).finally(() => {
        cfpLoadingBar.complete();
      });
    }

    function select(user) {
      // usersVm.usersList.push(user.id);
      user.selected = !user.selected;
      // user.selected = true;
    }

    function edit(user) {
      $location.path('/users/edit/' + user.id);
    }

    function changePassword(user) {
      $location.path('/users/' + user.id + '/changepassword');
    }

    function lockoutUser(user) {
      userService.lockoutUser(user.id)
        .then(() => {
          activate()
          FlashService.Success('User locked');
        })
        .catch(() => FlashService.Error('Could not lock user out'));
    }

    function unlockUser(user) {
      userService.unlockUser(user.id)
        .then(() => {
          activate()
          FlashService.Success('User unlocked');
        })
        .catch(() => FlashService.Error('Could not unlock user'));
    }
  });
